if (!customElements.get("uni-faq")) {
  customElements.define(
    "uni-faq",
    class UniFaq extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.details = Array.from(this.querySelectorAll("details"));
        this.details.forEach((details) => {
          this.prepareDetails(details);
          this.syncDetails(details, details.classList.contains("is-open"));
          this.bindSummaryToggle(details);
        });

        this.initialized = true;
      }

      prepareDetails(details) {
        const answer = details.querySelector(".uni-faq__answer");
        if (!answer) return;

        const isExpanded = details.classList.contains("is-open");
        details.open = true;
        answer.setAttribute("aria-hidden", isExpanded ? "false" : "true");
      }

      bindSummaryToggle(details) {
        const summary = details.querySelector("summary");
        const answer = details.querySelector(".uni-faq__answer");
        if (!summary || !answer) return;

        summary.addEventListener("click", (event) => {
          event.preventDefault();
          this.toggleDetails(details, answer);
        });
      }

      toggleDetails(details, answer) {
        const isExpanded = !details.classList.contains("is-open");

        details.classList.toggle("is-open", isExpanded);
        answer.setAttribute("aria-hidden", isExpanded ? "false" : "true");
        this.syncDetails(details, isExpanded);
      }

      syncDetails(details, isExpanded = details.open) {
        const summary = details.querySelector("summary");
        const icon = details.querySelector(".uni-faq__icon");

        if (summary) {
          summary.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        }

        if (icon) {
          icon.textContent = isExpanded ? "-" : "+";
        }
      }
    },
  );
}
